import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ListItemType } from 'shell/models/item-type';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface EuropeanUnionListComponentProps {
  disabled: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const EuropeanUnionListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: EuropeanUnionListComponentProps): React.ReactElement => {
  const {
    data,
    error: errorlist,
    get: getEuropeanUnionListComponent,
  } = useHttpFetch<HttpResponseList<ListItemType>>(
    `${__MUNICIPALITY_API_URL__}/geo/stato/unione-europea`,
    {
      data: {
        payload: {
          list: [],
        },
      },
    }
  );

  const list: Array<ItemVM> = useMemo(() => {
    if (!!errorlist || !data?.payload) {
      return [];
    }
    return data?.payload.list.map((item) => ({
      id: item.key,
      value: item.descrizione,
    }));
  }, [data, errorlist]);

  useEffect(() => {
    getEuropeanUnionListComponent();
  }, []);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="list-label">
        Unione Europea *
      </InputLabel>
      <PmiSelect
        labelId="list-label"
        id="ue"
        name="ue"
        value={value}
        label="Unione Europea *"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

EuropeanUnionListComponent.displayName = 'European Union item component';

const EuropeanUnionList = memo(EuropeanUnionListComponent);

export default EuropeanUnionList as typeof EuropeanUnionListComponent;
